import { WifiOff } from "lucide-react";
import useOnline from "../hooks/useOnline";

// Shown under the header while the browser is offline (Ordre 24-4, CDC V2 § 14.2): changes are refused until the connection is back —
// nothing is saved locally as if it were done, nothing is queued.
export default function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900" role="status" data-testid="offline-banner">
      <WifiOff size={16} className="shrink-0" aria-hidden />
      <span>Vous êtes hors connexion. Vous pouvez relire ce qui est affiché, mais aucune modification n'est enregistrée tant que la connexion n'est pas revenue.</span>
    </div>
  );
}
